import TileGreenImage from "../images/tile-green-green.png";
import TileCreamImage from "../images/tile-cream-cream.png";

export const pallete = {
  lightNeutral: {},
  darkNeutral: {
    light: "#354e48", //"#4d8878",
    main: "#304943", //"#36594f",
    tile: TileGreenImage,
  },
  warm: {
    main: "#f5eee8",
    light: "#fcf5ed",
    tile: TileCreamImage,
  },
  // cool: {
  //   main: "#9bc1bc",
  //   light: "#9bc1bc",
  // },
};
